{
  "open": "Console",
  "title": "Console of {{name}}",
  "clickToType": "Click the screen to type with your keyboard",
  "off": {
    "title": "The server is off",
    "text": "The console shows the screen of a running server. Turn it on and you will see it boot from the first second.",
    "powerOn": "Turn on"
  },
  "failed": {
    "title": "Could not connect to the console",
    "text": "The connection broke or never opened. Reconnecting starts a new session."
  },
  "disconnected": {
    "title": "Console disconnected",
    "text": "The session has ended. Reconnect to continue."
  },
  "keyboard": {
    "label": "On-screen keyboard",
    "modifiersHint": "Ctrl, Alt, Shift and Win stay held until the next key",
    "native": "System keyboard",
    "functionKeys": "F1–F12"
  },
  "typeDialog": {
    "title": "Type text",
    "description": "The console receives key presses, not text: each character is typed as on a US English keyboard. Non-Latin letters and emoji cannot be typed — use SSH for those.",
    "field": "Text",
    "enter": "Press Enter at the end",
    "submit": "Type",
    "skipped": "Characters not on the US layout, skipped: {{count}}",
    "descriptionRu": "The console receives key presses, not text: each character is typed with the keys of the Russian layout (ЙЦУКЕН) — switch the server to it. Latin letters cannot be typed this way."
  }
}
